import Vue from 'vue';
import Vuex from 'vuex';
import lang from './lang.store';
import homeSlider from './home-slider.store';
import roomHighlighted from './room-highlighted.store';
import businessSlider from './business-slider';
import blog from './blog.store';
import homeTexts from './home-texts.store';
import roomSearch from './room-search.store';
import client from './client.store';
import menu from './menu.store';
import zone from './zone.store';
import room from './room.store';
import search from './search.store';
import bookingStep2 from './booking-step2.store';
import bookingStep1 from './booking-step1.store';
import bookingStep3 from './booking-step3.store';
import preFetchRoom from './pre-fetch-room.store';
import mapWidget from './map-widget.store';
import clientAddresses from './client-addresses';
import countries from './countries.store';
import stripeCard from './stripe-card.store';
import forgotPassword from './forgot-password.store';
import resetPassword from './reset-password.store'
import shoppingCart from './shopping-cart.store'
import registration from './registration.store';
import conceptPage from './concept-page.store';
import conceptSlider from './concept-slider.store';
// import scBooking from './sc-booking.store';
import extras from './extras.store';
import extrasModal from './extras-modal.store';
import addressesModal from './addresses-modal.store';
import bookingHistory from './booking-history.store';
import loginModal from './login-modal.store'
import bookingStep4 from './booking-step4.store';
import proPage from './pro-page.store';
import proSlider from './pro-slider.store';
import investPage from './invest-page.store';
import investSlider from './invest-slider.store';
import privacyPage from './privacy-page.store';
import {StoreLogger} from "./plugins/store-logger.plugin";
import legalModal from "./legal-modal.store";
import mobileMenu from "./mobile-menu.store";
import imageModal from "./image-modal.store";
import equipment from "./equiment.store";
import resaPicker from './resa-picker.store'
import faq from './faq.store'
import {isAndroid, isIOS} from "mobile-device-detect";

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [StoreLogger],
  modules: {
    lang,
    resaPicker,
    homeSlider,
    legalModal,
    roomHighlighted,
    businessSlider,
    blog,
    homeTexts,
    roomSearch,
    client,
    faq,
    menu,
    zone,
    room,
    equipment,
    search,
    bookingStep1,
    bookingStep2,
    bookingStep3,
    bookingStep4,
    preFetchRoom,
    mapWidget,
    clientAddresses,
    countries,
    stripeCard,
    forgotPassword,
    resetPassword,
    shoppingCart,
    registration,
    conceptPage,
    conceptSlider,
    // scBooking,
    extras,
    extrasModal,
    addressesModal,
    bookingHistory,
    loginModal,
    proPage,
    proSlider,
    investPage,
    investSlider,
    privacyPage,
    mobileMenu,
    imageModal
  },
  state: {
    apiStatus: true,
    isAndroid,
    isIOS
  },
  getters: {
    isAuth: state => state.client.auth === true,
    lang: state => state.lang.currentLang,
    isAPIOnline: state => state.apiStatus,
  },
  mutations: {
    SET_API_STATUS (state, payload) {
      state.apiStatus = !!payload;
    }
  }
});
store.id = Math.floor(Math.random() * 1000);

export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js